const supportedTimezones = [
  // Portugal
  "Atlantic/Azores",
  "Atlantic/Madeira",
  "Europe/Lisbon",
  // United Kingdom
  "Europe/Belfast",
  "Europe/London",
  // Brazil
  "America/Araguaina",
  "America/Bahia",
  "America/Belem",
  "America/Boa_Vista",
  "America/Campo_Grande",
  "America/Cuiaba",
  "America/Eirunepe",
  "America/Fortaleza",
  "America/Maceio",
  "America/Manaus",
  "America/Noronha",
  "America/Porto_Velho",
  "America/Recife",
  "America/Rio_Branco",
  "America/Santarem",
  "America/Sao_Paulo",
  // Canada
  "America/Atikokan",
  "America/Blanc-Sablon",
  "America/Cambridge_Bay",
  "America/Coral_Harbour",
  "America/Creston",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Edmonton",
  "America/Fort_Nelson",
  "America/Glace_Bay",
  "America/Goose_Bay",
  "America/Halifax",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Moncton",
  "America/Montreal",
  "America/Nipigon",
  "America/Panama",
  "America/Pangnirtung",
  "America/Puerto_Rico",
  "America/Rainy_River",
  "America/Rankin_Inlet",
  "America/Regina",
  "America/Resolute",
  "America/St_Johns",
  "America/Swift_Current",
  "America/Thunder_Bay",
  "America/Toronto",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Winnipeg",
  "America/Yellowknife",
  "Canada/Eastern",
  // United States
  "America/Boise",
  "America/Chicago",
  "America/Denver",
  "America/Detroit",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Adak",
  "America/Anchorage",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Los_Angeles",
  "America/Menominee",
  "America/Metlakatla",
  "America/New_York",
  "America/Nome",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Phoenix",
  "America/Sitka",
  "America/Yakutat",
  "Pacific/Honolulu",
  "US/Arizona",
  "US/Hawaii",
];

const GalaxySupport: React.FC<any> = ({ children }) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isSupported = supportedTimezones.includes(timeZone);

  if (!isSupported) {
    return null;
  }

  return children;
};

export default GalaxySupport;
